import React, { useState } from "react";

import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";

import Typography from "@mui/material/Typography";

import Button from "components/Button";

import DeleteAccountModal from "./DeleteAccountModal";
import UpdatePasswordModal from "./UpdatePasswordModal";

import { useAppSelector } from "store/hooks";

import analytics from "services/analytics";
import { AnalyticsEvents } from "shared/constants/analytics";

import { styles } from "./styles";

const ProfileMain: React.FC = () => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isUpdatePasswordModalOpen, setIsUpdatePasswordModalOpen] =
    useState(false);

  const globalLoading = useAppSelector((state) => state.loading.isLoading);
  const user = useAppSelector((state) => state.user.user);
  const email = user?.email || "";
  const loginProvider = user?.loginProvider || "";

  const googleProvider = "Google";
  const facebookProvider = "Facebook";

  const handleDeleteAccount = () => {
    analytics().sendEvent(AnalyticsEvents.profile_delete_account);
    setIsDeleteModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
  };

  const handleUpdatePassword = () => {
    analytics().sendEvent(AnalyticsEvents.profile_update_password);
    setIsUpdatePasswordModalOpen(true);
  };

  const closeUpdatePasswordModal = () => {
    setIsUpdatePasswordModalOpen(false);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ width: { xs: "100%", sm: "480px" } }}>
        <Typography sx={{ mb: 0.5 }} variant="h3">
          Мій профіль
        </Typography>
        <Typography color="grey700">
          Керуйте своїми персональними даними
        </Typography>
        <Box sx={{ mt: 3, mb: 3 }}>
          <Typography sx={{ mb: 1 }} variant="subtitle2" color="grey800">
            Email
          </Typography>
          {globalLoading ? (
            <Skeleton animation="wave" height={56} />
          ) : (
            <Box sx={styles.emailContainer}>
              <Typography color="grey800">{email}</Typography>
            </Box>
          )}
        </Box>
        {loginProvider !== googleProvider &&
          loginProvider !== facebookProvider && (
            <>
              <Typography sx={{ mb: 0.5 }}>Оновити пароль</Typography>
              <Typography sx={{ mb: 1.5 }} color="grey700">
                Встановіть новий пароль для доступу до облікового запису.
              </Typography>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleUpdatePassword}
                withBorder
              >
                Оновити пароль
              </Button>
            </>
          )}
      </Box>
      <Box sx={styles.divider} />
      <Box sx={{ width: { xs: "100%", sm: "480px" } }}>
        <Typography sx={{ mb: 0.5 }}>Видалити обліковий запис</Typography>
        <Typography sx={{ mb: 1.5 }} color="grey700">
          Назавжди видалити всі ваші дані та все, що пов’язано з вашим обліковим
          записом.
        </Typography>
        <Button
          variant="contained"
          color="error"
          onClick={handleDeleteAccount}
          withBorder
        >
          Видалити обліковий запис
        </Button>
      </Box>
      <UpdatePasswordModal
        isOpen={isUpdatePasswordModalOpen}
        onClose={closeUpdatePasswordModal}
      />
      <DeleteAccountModal
        isOpen={isDeleteModalOpen}
        onClose={closeDeleteModal}
      />
    </Box>
  );
};

export default ProfileMain;
